import React from 'react';
import { useAuth } from '../hooks/useAuth';

export const PendingPage: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-8 text-center">
        <div className="w-16 h-16 mx-auto mb-4 bg-amber-100 rounded-full flex items-center justify-center">
          <span className="text-amber-600 text-2xl">⏳</span>
        </div>

        <h1 className="text-xl font-bold text-gray-900 mb-2">Access Pending</h1>

        <p className="text-sm text-gray-600 mb-4">
          Your account <strong>{user?.email}</strong> has been registered but is
          waiting for administrator approval.
        </p>

        <p className="text-sm text-gray-500 mb-6">
          An administrator will grant you access to the Research Editor. You will
          be able to sign in and start editing once access is granted. Please
          contact{' '}
          <a
            href="mailto:samureiser@tddt.org"
            className="text-blue-600 hover:underline"
          >
            samureiser@tddt.org
          </a>{' '}
          if you need immediate access.
        </p>

        <button
          onClick={logout}
          className="px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded hover:bg-gray-50"
        >
          Sign Out
        </button>
      </div>
    </div>
  );
};
